// extracted by mini-css-extract-plugin
export default {"outputWrapper":"Outputs_outputWrapper__qtF6n","outputBox":"Outputs_outputBox__v1rHG","selected":"Outputs_selected__IMmdC","outputTitle":"Outputs_outputTitle__P3X+3"};